export const OPENSALUD360_SUBDOMAIN = '360'
export const OPENSALUD_SUBDOMAIN = 'www.opensalud'
export const OPENSALUD_TEST_SUBDOMAIN = 'pruebas.opensalud'
export const OPENSALUD_DEV_SUBDOMAIN = 'desarrollo.opensalud'
export const OPENSALUD360_TEST_SUBDOMAIN = 'pruebas-360'
export const COMUNIDAD_SALUDABLE_SUBDOMAIN = 'comunidadsaludable'
export const VIDEO_SUBDOMAIN = 'video'
export const HEALTHY_HABITS_SUBDOMAIN = 'habitossaludables'
export const BARCELO_SUBDOMAIN = 'barcelo'
export const IBEROSTAR_SUBDOMAIN = 'iberostar'
export const WAMOS_SUBDOMAIN = 'wamos'
export const ASSEGUR_SUBDOMAIN = 'assegur'
export const NAUTALIA_SUBDOMAIN = 'nautalia'
export const CARREFOUR_SUBDOMAIN = 'carrefour'
export const MSM_SUBDOMAIN = 'msm'
export const INHEALTH_SUBDOMAIN = 'inhealth'

// Subdomains and prefixes for specific environments
export const DEV_PREFIX = 'desarrollo'
export const DEV_SUFFIX = '-dev'
export const DEV_KEYWORDS = [DEV_PREFIX, DEV_SUFFIX, INHEALTH_SUBDOMAIN]
export const TEST_PREFIX = 'pruebas'
export const TEST_SUFFIX = '-test'
export const TEST_KEYWORDS = [TEST_PREFIX, TEST_SUFFIX]
export const APP_SUBDOMAIN = 'app'
export const APP_DEV_SUBDOMAIN = `${APP_SUBDOMAIN}${DEV_SUFFIX}`
export const APP_TEST_SUBDOMAIN = `${APP_SUBDOMAIN}${TEST_SUFFIX}`




// WEBPACK FOOTER //
// ./src/constants/subdomains.js